import * as z from 'zod';

import { userRoleQuerySchema } from './user-role-query-schema';

export const userRoleUpdateSchema = userRoleQuerySchema
  .pick({
    id: true,
    name: true,
    azure_role_id: true,
  })
  .extend({
    permissions: z.array(z.number()),
  });

export type UserRoleUpdateSchema = z.infer<typeof userRoleUpdateSchema>;

export const userRoleCreateSchema = userRoleUpdateSchema.omit({
  id: true,
});

export type UserRoleCreateSchema = z.infer<typeof userRoleCreateSchema>;
